import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { StoreConfiguration } from 'src/app/models/types/Configuration/StoreConfiguration.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, Observable, startWith, tap } from 'rxjs';
import { Route } from 'src/app/models/enums/Route.enum';
import { ViewChild, ElementRef } from '@angular/core';
import { Role } from 'src/app/models/enums/Role.enum';
@Component({
  selector: 'app-set-store-page',
  imports: [SharedModule],
  templateUrl: './set-store-page.component.html',
  styleUrl: './set-store-page.component.scss'
})
export class SetStorePageComponent implements OnInit {

  @ViewChild('input') inputRef!: ElementRef<HTMLInputElement>;

  public filteredStores$!: Observable<StoreConfiguration[]>;
  public choosingStore: boolean = false;
  public selectedStore: StoreConfiguration | undefined;
  public searchControl: FormControl = new FormControl();
  public loading: boolean = false;
  public store: StoreConfiguration | undefined;

  public get isStoreSelected(): boolean {
    return !this.store;
  }
  public get isSelectedStoreSelected(): boolean {
    return !this.selectedStore;
  }

  public get isSelectedStore(): number | undefined {
    return this.selectedStore?.idStore;
  }

  constructor(
    public readonly authService: AuthService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.checkUserRole();

    this.loading = true;

    this.authService.storeSession$.subscribe(store => {
      this.store = store;
    });

    this.filteredStores$ = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        tap(() => this.loading = true),
        debounceTime(500),
        map(value => {
          return this.authService.availableStore.filter(store => {
            let foundByName = store.nameStore.toLowerCase().includes(value.trim().toLowerCase());
            let foundByCode = store.codeStore.toString().toLowerCase().includes(value.trim().toLowerCase());
            return foundByName || foundByCode
          })
        }),
        tap(() => this.loading = false)
      );

  }

  checkUserRole() {
    let role: Role = this.authService.user!.role;

  }

  handleInput(): void {

  }

  handleSelectStoreClick() {
    this.choosingStore = true;
    setTimeout(() => {
      this.inputRef?.nativeElement.focus();
    });
  }

  handleDoneClick() {
    if (this.store) {
      this.authService.setStore(this.store);
      this.authService.loadSettings();
      this.router.navigate([`/${Route.Main}`]);
    }
  }

  handleChooseClick() {
    this.store = this.selectedStore;
    this.choosingStore = false;
  }

  handleSelectStore(store: StoreConfiguration) {
    this.selectedStore = store;
  }
}
